export const DBConfig = {
  name: 'offlineDB',
  objectStoresMeta: [
    {
      store: 'videos',
      storeConfig: { autoIncrement: false, keyPath: 'id' },
      storeSchema: [
        { keypath: 'video', name: 'video', options: { unique: false } },
        { keypath: 'id', name: 'id', options: { unique: true } },
        { keypath: 'sortedArr', name: 'sortedArr' },
      ],
    },
    {
      store: 'video_url',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [{ keypath: 'url', name: 'url', options: { unique: true } }],
    },
    {
      store: 'image',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'url', name: 'url', options: { unique: true } },
        { keypath: 'id', name: 'id', options: { unique: true } },
        { keypath: 'file', name: 'file' },
      ],
    },
    {
      store: 'modules',
      storeConfig: { autoIncrement: false, keyPath: 'id' },
      storeSchema: [
        { keypath: 'course_id', name: 'course_id', options: { unique: false } },
        { keypath: 'id', name: 'id', options: { unique: true } },
        { keypath: 'title', name: 'title' },
        { keypath: 'lessons', name: 'lessons' },
        { keypath: 'final_test', name: 'final_test' },
        { keypath: 'is_available', name: 'is_available' },
        { keypath: 'current_lesson', name: 'current_lesson' },
      ],
    },
    {
      store: 'completed_course',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'user_id',
          name: 'user_id',
        },
        {
          keypath: 'course_id',
          name: 'course_id',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
    {
      store: 'completed_course_module',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'user_id',
          name: 'user_id',
        },
        {
          keypath: 'course_module_id',
          name: 'course_module_id',
        },
        {
          keypath: 'completion_type',
          name: 'completion_type',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
    {
      store: 'completed_lesson',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'user_id',
          name: 'user_id',
        },
        {
          keypath: 'lesson_id',
          name: 'lesson_id',
        },
        {
          keypath: 'completion_type',
          name: 'completion_type',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
    {
      store: 'completed_lesson_activity',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'user_id',
          name: 'user_id',
        },
        {
          keypath: 'activity_id',
          name: 'activity_id',
        },
        {
          keypath: 'completion_type',
          name: 'completion_type',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
    {
      store: 'completed_test',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'user_id',
          name: 'user_id',
        },
        {
          keypath: 'test_id',
          name: 'test_id',
        },
        {
          keypath: 'correct_answers',
          name: 'correct_answers',
        },
        {
          keypath: 'attempt_number',
          name: 'attempt_number',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
    {
      store: 'completed_test_step',
      storeConfig: { autoIncrement: true, keyPath: 'id' },
      storeSchema: [
        { keypath: 'id', name: 'id', options: { unique: true } },
        {
          keypath: 'test_step_id',
          name: 'test_step_id',
        },
        {
          keypath: 'completed_test_id',
          name: 'completed_test_id',
        },
        {
          keypath: 'choosen_test_step_option_id',
          name: 'choosen_test_step_option_id',
        },
        { keypath: 'started_at', name: 'started_at' },
        { keypath: 'completed_at', name: 'completed_at' },
      ],
    },
  ],
  version: 1,
};
